import { useQuery } from "@tanstack/react-query";
import { getSubscriptionPlans } from "@/api/tenants";

/** Cached subscription-plan catalog (rarely changes). */
export function usePlans() {
  return useQuery({
    queryKey: ["subscription-plans"],
    queryFn: getSubscriptionPlans,
    staleTime: 60 * 60 * 1000, // 1h
    gcTime: 24 * 60 * 60 * 1000, // 24h
  });
}
